module.exports = __webpack_public_path__ + "static/media/GAOFEN 6.0bf77605.czml";